import React, { useCallback, useContext } from 'react';
import Dropzone, { IFileWithMeta, StatusValue } from 'react-dropzone-uploader';
import { useDispatch, useSelector } from 'react-redux';
import { selectLists } from '../../../../store/modules/lists/selectors';

import { uploadStyles } from './upload-media/styles';
import InputContent from './upload-media/InputContent';
import Layout from './upload-media/Layout';
import { setOpenMediaUpload } from '../../../../store/modules/articles/actions';
import { UploadContext } from '../useUploadFiles';

const UploadMedia = () => {
  const styles = uploadStyles();
  const dispatch = useDispatch();
  const lists = useSelector(selectLists);
  const { addFile } = useContext(UploadContext);

  const accepts = lists.data ? lists.data['document-mime-types']
    .map((item) => `.${item.extension.toLocaleLowerCase()}`).join(',') : '*';

  const onChangeStatus = useCallback((file: IFileWithMeta, status: StatusValue, allFiles: IFileWithMeta[]) => {
    if (status === 'rejected_file_type') {
      const rejectFiles = allFiles.filter((item) => item.meta.size === undefined);
      rejectFiles.forEach((item) => item.remove());
    } else if (status === 'preparing') {
      addFile(file);
      dispatch(setOpenMediaUpload(true));
    }
  }, [dispatch, addFile]);

  return (
    <Dropzone
      accept={accepts}
      multiple
      canCancel={false}
      canRemove={false}
      LayoutComponent={Layout}
      inputContent={<InputContent key={1} />}
      inputWithFilesContent={<InputContent key={1} />}
      onChangeStatus={onChangeStatus}
      classNames={{
        dropzone: styles.dropzone,
        dropzoneActive: styles.dropzoneActive,
        input: styles.input,
        inputLabel: styles.inputLabel,
        inputLabelWithFiles: styles.inputLabel,
        preview: styles.preview,
        previewImage: styles.previewImage,
      }}
    />
  );
};

export default UploadMedia;
